module.exports = __webpack_public_path__ + "img/forgot_password.78abb34b.svg";